module.exports = __webpack_public_path__ + "img/wuxing01.59c2b4da.png";